var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Search, SEARCH_MODE } from "./..";
import { searchCategoryAddon } from "./searchCategoryAddon";
import { createUIElement, useStateValue } from "../../helpers";
import { calcWidth } from "../../helpers/styles";
import { CONTROL_SIZE } from "../../common/public";
export var MIN_WIDTH_CATEGORIZED_SEARCH = calcWidth(CONTROL_SIZE.l);
var StyledSearch = styled(Search)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), MIN_WIDTH_CATEGORIZED_SEARCH);
export var CategorizedSearch = createUIElement('CategorizedSearch', function (_a, ref) {
    var className = _a.className, termValue = _a.termValue, categoryValue = _a.categoryValue, onTermChange = _a.onTermChange, onCategoryChange = _a.onCategoryChange, onSearch = _a.onSearch, categories = _a.categories, _b = _a.categorySize, categorySize = _b === void 0 ? CONTROL_SIZE.xs : _b, _c = _a.size, size = _c === void 0 ? CONTROL_SIZE.l : _c, mode = _a.mode, placeholder = _a.placeholder, maxLength = _a.maxLength, performed = _a.performed, onClear = _a.onClear, hasSearchButton = _a.hasSearchButton, disabled = _a.disabled, _d = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _d === void 0 ? true : _d, searchDebounceTimeInMs = _a.searchDebounceTimeInMs, onFocus = _a.onFocus, onBlur = _a.onBlur, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "termValue", "categoryValue", "onTermChange", "onCategoryChange", "onSearch", "categories", "categorySize", "size", "mode", "placeholder", "maxLength", "performed", "onClear", "hasSearchButton", "disabled", "hasEnterKeyStopPropagation", "searchDebounceTimeInMs", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var termState = useStateValue(termValue, [termValue], {
        onChange: function (value) { return onTermChange === null || onTermChange === void 0 ? void 0 : onTermChange(value || ''); }
    });
    var categoryState = useStateValue(categoryValue, [categoryValue], {
        onChange: function (value) { return onCategoryChange === null || onCategoryChange === void 0 ? void 0 : onCategoryChange(value); }
    });
    var search = function () {
        onSearch === null || onSearch === void 0 ? void 0 : onSearch({
            term: termState.getValue() || '',
            category: categoryState.getValue()
        });
    };
    return (React.createElement(StyledSearch, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-CategorizedSearch " + className, size: size, value: termState.getValue(), onChange: termState.setValue, renderRightAddon: searchCategoryAddon({
            value: categoryState.getValue(),
            onChange: function (nextValue) {
                categoryState.setValue(nextValue);
                if (mode === SEARCH_MODE.automatic) {
                    search();
                }
            },
            options: categories,
            size: categorySize
        }), onSearch: function () {
            search();
        }, mode: mode, placeholder: placeholder, maxLength: maxLength, performed: performed, onClear: onClear, hasSearchButton: hasSearchButton, disabled: disabled, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, searchDebounceTimeInMs: searchDebounceTimeInMs, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
var templateObject_1;
//# sourceMappingURL=CategorizedSearch.js.map